// ----------------------------------------------------------------------------
// Component: Product Hotspots
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import './_product-hotspots.scss';


// -------------------------------------
// Variables
// -------------------------------------

var HOTSPOT              = '.hotspot';
var HOTSPOT_DATA         = 'hotspot-target';
var HOTSPOT_BUTTON       = '.hotspot-item__toggle-button';
var HOTSPOT_ITEM_CONTENT = '.hotspot-item__content';


// Constant trigger classes
var OPEN_CLASS          = 'is-open';


// -------------------------------------
// Helper Functions
// -------------------------------------

function handleHotspot(hotspot) {
    hotspot.$item.parent().find('.' + OPEN_CLASS).removeClass(OPEN_CLASS);
    hotspot.$item.parent().find(HOTSPOT_ITEM_CONTENT).css('overflow', 'hidden').attr('hidden', true);
    hotspot.$item.parent().find(HOTSPOT_BUTTON).attr('aria-expanded', 'false');
    hotspot.$item.parent().find(HOTSPOT_ITEM_CONTENT + " a").attr('tabindex', -1);
    $(HOTSPOT_BUTTON).not(OPEN_CLASS).removeClass(OPEN_CLASS);
    $(HOTSPOT_BUTTON).not(OPEN_CLASS).attr('aria-expanded', 'false');

    if (hotspot.isOpening) {
        hotspot.$target
            .add(hotspot.$button)
            .add(hotspot.$item)
            .add(hotspot.$item.find(HOTSPOT_BUTTON))
            .add(hotspot.$content)
            .addClass(OPEN_CLASS);

        hotspot.$target.attr('aria-expanded', 'true');
        hotspot.$button.attr('aria-expanded', 'true');
        hotspot.$content.attr('hidden', false);
        hotspot.$content.find('a').attr('tabindex', null);

        // This allows select boxes to flow out after it's opened
        setTimeout(function() {
            hotspot.$content.css('overflow', 'visible');
        }, 200);
    }
}

function hotspotOnHover(e) {
    e.preventDefault();
    var hotspotButtons = document.querySelectorAll('#' + $(e.currentTarget).data(HOTSPOT_DATA) + '__button');

    if (e.type === 'mouseenter') {
        setTimeout(function(event){
            for (const hotspotButton of hotspotButtons) {
                hotspotButton.classList.add('is-hover');
            }
        }, 150);

    }
    if (e.type === 'mouseleave') {
        setTimeout(function(event){
            for (const hotspotButton of hotspotButtons) {
                hotspotButton.classList.remove('is-hover');
            }
        }, 150);
    }
}

function hoverHotspot() {
    if ($(window).width() >= 1025) {
        $('[data-hotspot-target]').on('mouseenter mouseleave', hotspotOnHover)
    } else {
        $('[data-hotspot-target]').off('mouseenter mouseleave', hotspotOnHover)
    }
}


// -------------------------------------
// Hooks
// -------------------------------------

hoverHotspot();
$(window).on('resize', hoverHotspot);

$(HOTSPOT_ITEM_CONTENT + " a").attr('tabindex', -1);

$(HOTSPOT_BUTTON).on('click keydown', function(e) {
    /**
     * click: Check state of the hotspot item then pass on an action
     *
     * @param {Event} e
     * @return void
     */
    //e.preventDefault();
    // Store elements as an object
    var hotspot = {
        $target:    $(e.target),
        $button:    $('#' + $(e.target).data(HOTSPOT_DATA) + '__button'),
        $data:      $(e.target).data(HOTSPOT_DATA),
        $item:      $('#' + $(e.target).data(HOTSPOT_DATA)),
        $content:   $('#' + $(e.target).data(HOTSPOT_DATA) + '__content'),
        isOpening:  !$(e.target).hasClass(OPEN_CLASS),
        $button_group: $(e.target).closest(HOTSPOT).find(HOTSPOT_BUTTON)
    };
    // Collapse any open sibling & children hotspots if data attribute set to true
    if (e.type === 'click') {
        e.preventDefault();
        handleHotspot(hotspot);
    }
    else if (e.type === 'keydown') {
        let key = e.which.toString();
        if (key.match(/35|36|38|40/)) {
            e.preventDefault();
            let index = $.inArray(e.target, hotspot.$button_group);
            let length = hotspot.$button_group.length;
            let newIndex;
            switch(key) {
                case '38': // Up
                    newIndex = (index + length + -1) % length;
                    hotspot.$button_group[newIndex].focus();
                    break;
                case '40': // Down
                    newIndex = (index + length + 1) % length;
                    hotspot.$button_group[newIndex].focus();
                    break;
                case '35': // End
                    hotspot.$button_group[length - 1].focus();
                    break;
                case '36': // Home
                    hotspot.$button_group[0].focus();
                    break;
            }
        }
    }
});